import React from 'react';
import PropTypes from 'prop-types';

const Loader = ({ showSpinner }) => {
  if (!showSpinner) return null;

  return <div className="loader"></div>;
};

Loader.propTypes = {
  showSpinner: PropTypes.bool.isRequired
};

export default Loader;
